const imageCache = new Map();

export function preloadImage(src) {
  if (!src) {
    return Promise.resolve();
  }

  const cached = imageCache.get(src);
  if (cached) {
    return cached;
  }

  const promise = new Promise((resolve) => {
    const image = new Image();

    const finish = () => {
      resolve();
    };

    image.onload = () => {
      if (typeof image.decode === "function") {
        image.decode().then(finish).catch(finish);
        return;
      }

      finish();
    };

    image.onerror = finish;
    image.src = src;

    if (image.complete) {
      finish();
    }
  });

  imageCache.set(src, promise);
  return promise;
}
